import { saveAs } from 'file-saver'

export const base64toBlob = (
    base64Data: string,
    mimeType: string = 'application/pdf'
) => {
    var sliceSize = 1024
    var byteCharacters = atob(base64Data)
    var bytesLength = byteCharacters.length
    var slicesCount = Math.ceil(bytesLength / sliceSize)
    var byteArrays = new Array(slicesCount)
    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize
        var end = Math.min(begin + sliceSize, bytesLength)
        var bytes = new Array(end - begin)
        for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0)
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes)
    }
    return new Blob(byteArrays, { type: mimeType })
}

export const downloadBase64DataAsZip = (
    fileName: string,
    base64String: string
) => {
    let file = base64toBlob(base64String, 'application/zip')
    saveAs(file, fileName)
}
